(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pickens-events-welcome"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    const roots = scope.matches?.('[data-pc-event-welcome]') ? [scope] : scope.querySelectorAll('[data-pc-event-welcome]');
    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const params = new URLSearchParams(window.location.search);
      const heading = root.querySelector('[data-pc-event-heading]');
      const intro = root.querySelector('[data-pc-event-intro]');
      const eyebrow = root.querySelector('[data-pc-event-eyebrow]');
      const media = root.querySelector('[data-pc-hero-media]');
      const heroInner = root.querySelector('[data-pc-hero-inner]');
      const defaults = {heading: heading.textContent, intro: intro.textContent, eyebrow: eyebrow.textContent};
      const originalImage = media.querySelector('img')?.cloneNode(true);
      const records = new Map();
      root.querySelectorAll('[data-pc-event-record]').forEach((element) => {
        try {
          const record = JSON.parse(element.querySelector('script').textContent);
          if (!record.id || records.has(record.id)) return;
          record.blockId = element.dataset.blockId;
          record.image = element.querySelector('template');
          records.set(record.id, record);
        } catch {}
      });
      const safeValue = (value, fallback) => /^[a-zA-Z0-9_-]{1,100}$/.test(value || '') ? value : fallback;
      const showEvent = (event) => {
        const id = event?.id || 'general';
        root.dataset.eventId = id;
        heading.textContent = event?.heading || defaults.heading;
        intro.textContent = event?.intro || defaults.intro;
        const eventLine = [event?.name, event?.location, event?.date].filter(Boolean).join(' · ');
        eyebrow.textContent = eventLine || defaults.eyebrow;
        const band = root.querySelector('[data-pc-event-band]');
        band.textContent = eventLine;
        band.hidden = !eventLine;
        const eventImage = event?.image?.content.querySelector('img');
        const nextImage = eventImage || originalImage;
        media.replaceChildren(...(nextImage ? [nextImage.cloneNode(true)] : []));
        media.hidden = !nextImage;
        heroInner.classList.toggle('pc-ew__hero-inner--no-image', !nextImage);
        const tags = root.querySelector('[data-pc-event-tags]');
        if (tags) tags.value = 'newsletter, interest-list, events-welcome, event-' + id;
        const tracking = {
          utm_source: safeValue(params.get('utm_source'), event ? event.source || 'events' : ''),
          utm_medium: safeValue(params.get('utm_medium'), event ? 'qr' : ''),
          utm_campaign: safeValue(params.get('utm_campaign'), event ? event.campaign || 'events' : ''),
          utm_content: safeValue(params.get('utm_content'), event ? 'welcome_page' : '')
        };
        root.querySelectorAll('[data-pc-event-link]').forEach((link) => {
          if (!link.dataset.baseHref) link.dataset.baseHref = link.getAttribute('href');
          const target = new URL(link.dataset.baseHref, window.location.origin);
          if (target.origin !== window.location.origin) return;
          Object.entries(tracking).forEach(([key,value]) => { if (value) target.searchParams.set(key,value); });
          if (event) target.searchParams.set('event',id);
          link.setAttribute('href',target.pathname + target.search + target.hash);
        });
        const returnInput = root.querySelector('[data-pc-event-return]');
        if (returnInput) {
          const target = new URL(window.location.pathname, window.location.origin);
          if (event) target.searchParams.set('event',id);
          Object.entries(tracking).forEach(([key,value]) => { if (value) target.searchParams.set(key,value); });
          target.searchParams.set('customer_posted','true');
          target.hash = root.id + '-signup';
          returnInput.value = target.pathname + target.search + target.hash;
        }
      };
      const initialEvent = records.get(root.dataset.editor === 'true' ? root.dataset.previewEvent : params.get('event'));
      showEvent(initialEvent);
      if (root.dataset.editor !== 'true') root.querySelectorAll('[data-pc-cta]').forEach((link) => {
        link.addEventListener('click', () => {
          if (typeof window.Shopify?.analytics?.publish !== 'function') return;
          try {
            const sent = window.Shopify.analytics.publish('pickens_event_cta', {event_id:root.dataset.eventId, cta:link.dataset.pcCta});
            if (typeof sent?.catch === 'function') sent.catch(() => {});
          } catch {}
        });
      });
      if (root.dataset.editor === 'true') {
        root.addEventListener('shopify:block:select', (event) => {
          const selected = [...records.values()].find((record) => record.blockId === event.detail.blockId);
          if (selected) showEvent(selected);
        });
        root.addEventListener('shopify:block:deselect', () => showEvent(initialEvent));
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pickens-x-seam"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (customElements.get('pickens-xseam')) return;

  class PickensXseam extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;

      this._form = this.querySelector('[data-xseam-form]');
      this._input = this.querySelector('[data-xseam-input]');
      this._unit = this.querySelector('[data-xseam-unit]');
      this._result = this.querySelector('[data-xseam-result]');
      this._error = this.querySelector('[data-xseam-error]');
      this._cards = Array.from(this.querySelectorAll('[data-size-card]'));
      if (!this._form || !this._input || !this._unit || !this._result || !this._error) return;

      this._connected = true;
      this._previousUnit = this._unit.value;
      this._form.noValidate = true;
      this._clear();

      this._input.addEventListener('input', () => this._clear());
      this._unit.addEventListener('change', () => {
        const value = this._number();
        const nextUnit = this._unit.value;
        if (value !== null && nextUnit !== this._previousUnit) {
          const converted = nextUnit === 'cm' ? value * 2.54 : value / 2.54;
          if (Number.isFinite(converted)) {
            this._input.value = String(Math.round(converted * 1000) / 1000);
          }
        }
        this._previousUnit = nextUnit;
        this._input.placeholder = nextUnit === 'cm' ? 'e.g. 106.68' : 'e.g. 42';
        this._clear();
      });
      this._form.addEventListener('submit', (event) => {
        event.preventDefault();
        this._check();
      });
    }

    _number() {
      const raw = this._input.value.trim();
      if (!/^(?:\d+(?:[.,]\d*)?|[.,]\d+)$/.test(raw)) return null;
      const value = Number(raw.replace(',', '.'));
      return Number.isFinite(value) && value > 0 ? value : null;
    }

    _clear() {
      this._error.textContent = '';
      this._error.hidden = true;
      this._input.removeAttribute('aria-invalid');
      this._result.replaceChildren();
      this._result.removeAttribute('data-result-state');
      this._cards.forEach((card) => {
        card.dataset.match = 'false';
        const badge = card.querySelector('[data-match-badge]');
        if (badge) badge.hidden = true;
      });
    }

    _check() {
      this._clear();
      const value = this._number();
      if (value === null) {
        this._error.textContent = 'Enter a measurement greater than zero, using numbers and an optional decimal point or comma.';
        this._error.hidden = false;
        this._input.setAttribute('aria-invalid', 'true');
        this._input.focus();
        return;
      }

      const inches = this._unit.value === 'cm' ? value / 2.54 : value;
      const epsilon = 1e-9;
      const small = inches >= 33 - epsilon && inches <= 40 + epsilon;
      const standard = inches >= 39.5 - epsilon && inches <= 48 + epsilon;
      let state;
      let heading;
      let body;

      if (small && standard) {
        state = 'overlap';
        heading = 'Both ranges include your measurement.';
        body = 'Your X-seam falls in the overlap between Small and Standard. We can help you compare the options and confirm your riding position before you choose.';
      } else if (small) {
        state = 'small';
        heading = 'Your measurement is within the Small range.';
        body = 'Small is a starting point for your fit conversation. If your measurement is close to either end of the range, let us confirm pedal reach and riding position with you.';
      } else if (standard) {
        state = 'standard';
        heading = 'Your measurement is within the Standard range.';
        body = 'Standard is a starting point for your fit conversation. If your measurement is close to either end of the range, let us confirm pedal reach and riding position with you.';
      } else {
        state = 'outside';
        heading = 'Let’s confirm your fit together.';
        body = 'Your measurement is outside the published Small and Standard ranges. Check your measurement using the guide above, then contact us to discuss fit before choosing a trike.';
      }

      this._cards.forEach((card) => {
        const matches = card.dataset.sizeCard === 'small' ? small : card.dataset.sizeCard === 'standard' && standard;
        card.dataset.match = String(matches);
        const badge = card.querySelector('[data-match-badge]');
        if (badge) badge.hidden = !matches;
      });

      const eyebrow = document.createElement('span');
      eyebrow.className = 'pc-xs__eyebrow';
      eyebrow.textContent = 'Range check';
      const title = document.createElement('h3');
      title.textContent = heading;
      const explanation = document.createElement('p');
      explanation.textContent = body;
      const note = document.createElement('p');
      note.className = 'px-result-note';
      note.textContent = 'This guide checks the published X-seam ranges. It does not confirm overall fit.';

      this._result.dataset.resultState = state;
      this._result.append(eyebrow, title, explanation, note);
    }
  }

  customElements.define('pickens-xseam', PickensXseam);
})();


  } catch(e) { console.error(e); }
})();
})();
